import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("clazing_token") || sessionStorage.getItem("clazing_token");
  const deviceId = localStorage.getItem("clazing_desktop_device_id")
    || localStorage.getItem("clazing_mobile_device_id");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (deviceId) config.headers["X-Clazing-Device"] = deviceId;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Er is iets misgegaan.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return JSON.stringify(detail);
}

export default api;
